import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "flapjack_cart";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const setQty = (lookup_key, quantity) =>
      setItems((prev) =>
        quantity <= 0
          ? prev.filter((i) => i.lookup_key !== lookup_key)
          : prev.map((i) => (i.lookup_key === lookup_key ? { ...i, quantity } : i)),
      );
    const add = (lookup_key) =>
      setItems((prev) => {
        const f = prev.find((i) => i.lookup_key === lookup_key);
        if (f) return prev.map((i) => (i.lookup_key === lookup_key ? { ...i, quantity: i.quantity + 1 } : i));
        return [...prev, { lookup_key, quantity: 1 }];
      });
    const count = items.reduce((s, i) => s + i.quantity, 0);
    return { items, add, setQty, clear: () => setItems([]), count, open, setOpen };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
